import { Select as RadixSelect } from '@radix-ui/themes';

import { FlyThemeColor } from '../utils';

type SelectSize = '1' | '2' | '3';

export type SelectProps = Omit<RadixSelect.RootProps, 'size'> &
  Omit<RadixSelect.TriggerProps, 'color' | 'radius'> & {
    options: SelectOption[];
    label?: React.ReactNode;
    error?: React.ReactNode;
    color?: FlyThemeColor;
    size?: SelectSize;
    loading?: boolean;
    searchable?: boolean;
    searchPlaceholder?: string;
  };

export type SelectOption = RadixSelect.ItemProps;

export const sizeToTriggerClassName: Record<SelectSize, string> = {
  '1': 'text-size-fly-1',
  '2': 'text-size-fly-2',
  '3': 'text-size-fly-3',
};
